import { useState, useEffect, useRef } from 'react';
import { useTranslation } from "react-i18next";
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import findPerfil from '../../service/findPerfil';
import inativarPerfil from '../../service/inativarPerfil';
import ativarPerfil from '../../service/ativarPerfil';
import { Button } from 'primereact/button';
import { SortOrder } from 'primereact/api';
import { useGlobalState } from '../../components/globalState/GlobalStateProvider';
import React from 'react';
import { InputText } from 'primereact/inputtext';
import { Nullable } from 'primereact/ts-helpers';
import { Toolbar } from 'primereact/toolbar';
import { Dropdown } from 'primereact/dropdown';
import { Tag } from 'primereact/tag';
import { Toast } from 'primereact/toast';
import { ConfirmDialog, confirmDialog } from 'primereact/confirmdialog';

export default function PerfilList({ onEdit }: { onEdit: (perfil: any) => void }) {
  const { t } = useTranslation();
  const [perfis, setPerfis] = useState(undefined);
  const [totalRecords, setTotalRecords] = useState(0);
  const { state } = useGlobalState();
  const [descricao, setDescricao] = useState<Nullable<String | null>>(null);
  const toast = useRef<Toast>(null);
  const [lazyState, setlazyState] = useState({
    first: 0,
    rows: 10,
    page: 1,
    descricao: descricao,
    idFranquia: state.user.franquiaSelected?.id ? state.user.franquiaSelected?.id : null,
    ativo: true as boolean | null,
    sortField: 'descricao',
    sortOrder: SortOrder.ASC
  });

  const STATUS_TODOS = 'TODOS';
  const statusOptions = [
    { label: t('todos'), value: STATUS_TODOS },
    { label: t('ativo'), value: 'true' },
    { label: t('inativo'), value: 'false' },
  ];
  const statusDropdownValue = lazyState.ativo === null ? STATUS_TODOS : String(lazyState.ativo);

  const onPage = (event: any) => {
    setlazyState({
      first: event.first,
      rows: event.rows,
      page: (event.first / event.rows) + 1,
      descricao: descricao,
      idFranquia: state.user.franquiaSelected?.id ? state.user.franquiaSelected?.id : null,
      ativo: lazyState.ativo,
      sortField: event.sortField,
      sortOrder: event.sortOrder
    });
  };
  const onSort = (event: any) => {
    setlazyState({
      first: 0,
      rows: 10,
      page: 1,
      descricao: descricao,
      idFranquia: state.user.franquiaSelected?.id ? state.user.franquiaSelected?.id : null,
      ativo: lazyState.ativo,
      sortField: event.sortField,
      sortOrder: event.sortOrder
    });
  };

  const changeDescricao = (desc: Nullable<String>) => {
    const valor = desc && String(desc).trim().length ? desc : null;
    setDescricao(valor);
    setlazyState({
      first: 0,
      rows: 10,
      page: 1,
      descricao: valor,
      idFranquia: state.user.franquiaSelected?.id ? state.user.franquiaSelected?.id : null,
      ativo: lazyState.ativo,
      sortField: 'descricao',
      sortOrder: SortOrder.ASC
    });
  }

  const changeStatus = (e: any) => {
    const novoAtivo = e.value === STATUS_TODOS ? null : e.value === 'true';
    setlazyState({
      first: 0,
      rows: 10,
      page: 1,
      descricao: descricao,
      idFranquia: state.user.franquiaSelected?.id ? state.user.franquiaSelected?.id : null,
      ativo: novoAtivo,
      sortField: lazyState.sortField,
      sortOrder: lazyState.sortOrder
    });
  };

  const startContent = (
    <React.Fragment>
      <div style={{ background: 'transparent' }}>
        <div className="grid">
          <div className="col p-fluid flex flex-wrap">
            <div>
              <div className="flex-auto">
                <label htmlFor="descricao" className="font-bold block mb-2">{t('descricao')} </label>
                <InputText id="descricao" onBlur={(e) => changeDescricao(e.target.value)} style={{ width: '20rem' }}></InputText>
              </div>
            </div>
          </div>
          <div className="col-3 p-fluid flex flex-wrap">
            <div>
              <div className="flex-auto">
                <label htmlFor="status" className="font-bold block mb-2">Status</label>
                <Dropdown inputId="status" value={statusDropdownValue} options={statusOptions} optionValue="value" onChange={changeStatus} style={{ width: '15rem' }} />
              </div>
            </div>
          </div>
        </div>
      </div>
    </React.Fragment>
  );

  const loadLazyData = () => {
    findPerfil(lazyState).then(data => { setTotalRecords(data.total); setPerfis(data.perfis) }).catch(() => { setTotalRecords(0); setPerfis(undefined) });
  }

  const editBodyTemplate = (perfil: any) => {
    return <Button icon="pi pi-pencil" onClick={() => onEdit(perfil)} style={{ background: 'transparent', color: 'gray', border: 'none' }} />;
  };

  const statusBodyTemplate = (perfil: any) => {
    return perfil.inativo === true
      ? <Tag icon="pi pi-pause-circle" severity="warning" value={t('inativo')} />
      : <Tag icon="pi pi-check-circle" severity="success" value={t('ativo')} />;
  };

  const executarAtivar = (perfil: any) => {
    ativarPerfil(perfil.id).then((mensagem) => {
      if (mensagem && mensagem.includes('Erro')) {
        toast.current?.show({ severity: 'warn', summary: t('erro'), detail: mensagem, life: 6000 });
        return;
      }
      toast.current?.show({ severity: 'success', summary: t('sucesso'), detail: mensagem, life: 3000 });
      loadLazyData();
    }).catch((error) => {
      toast.current?.show({ severity: 'error', summary: t('erro'), detail: error?.message || String(error), life: 5000 });
    });
  };

  const executarInativar = (perfil: any) => {
    inativarPerfil(perfil.id).then((mensagem) => {
      if (mensagem && mensagem.includes('Erro')) {
        toast.current?.show({ severity: 'warn', summary: t('erro'), detail: mensagem, life: 6000 });
        return;
      }
      toast.current?.show({ severity: 'success', summary: t('sucesso'), detail: mensagem, life: 3000 });
      loadLazyData();
    }).catch((error) => {
      toast.current?.show({ severity: 'error', summary: t('erro'), detail: error?.message || String(error), life: 5000 });
    });
  };

  const confirmarInativar = (perfil: any) => {
    confirmDialog({
      message: `${t('confirmarInativarPerfil')} "${perfil.descricao}"?`,
      header: t('inativar') as string,
      icon: 'pi pi-exclamation-triangle',
      acceptLabel: t('inativar') as string,
      rejectLabel: t('cancelar') as string,
      accept: () => executarInativar(perfil)
    });
  };

  const statusActionBodyTemplate = (perfil: any) => {
    return perfil.inativo === true
      ? <Button icon="pi pi-check-circle" tooltip={t('ativar') as string} tooltipOptions={{ position: 'top' }} onClick={() => executarAtivar(perfil)} style={{ background: 'transparent', color: 'gray', border: 'none' }} />
      : <Button icon="pi pi-ban" tooltip={t('inativar') as string} tooltipOptions={{ position: 'top' }} onClick={() => confirmarInativar(perfil)} style={{ background: 'transparent', color: '#e24c4c', border: 'none' }} />;
  };

  useEffect(() => {
    loadLazyData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [lazyState])

  return (
    <div>
      <Toast ref={toast} />
      <ConfirmDialog />
      <div>
        <Toolbar start={startContent} />
        <br></br>
        <br></br>
        <DataTable value={perfis} first={lazyState.first} dataKey="id" paginator={true} lazy={true}
          emptyMessage="Sem registros"
          onSort={onSort} sortField={lazyState.sortField} sortOrder={lazyState.sortOrder}
          rows={lazyState.rows} totalRecords={totalRecords} onPage={onPage}
          tableStyle={{ minWidth: '75rem' }}>

          <Column field="descricao" sortable header={t('descricao')} />
          <Column body={statusBodyTemplate} header="Status" />
          <Column body={editBodyTemplate} />
          <Column body={statusActionBodyTemplate} />
        </DataTable>
      </div>
    </div>
  )
}
